export default __webpack_public_path__ + "static/media/31.f87f5a2d.gif";